import React from "react";
import MenuItem from "material-ui/MenuItem";
import Style from "../constants/style";

export default class CustomMenuItem extends React.PureComponent {
    render() {
        const {
            primaryText = "",
            value,
            secondaryText = "",
            checked = false,
            insetChildren = false,
            focusState = "none",
            innerDivStyle = {},
            anchorOrigin,
            targetOrigin,
            menuItems,
            style = {}
        } = this.props;
        return (
            <MenuItem
                {...this.props}
                className={`${this.props.showMenuItemNewStyle ? "newHoverMenu" : ""} ${
                    this.props.className
                }`}
                secondaryText={secondaryText}
                primaryText={primaryText}
                value={value}
                checked={checked}
                insetChildren={insetChildren}
                focusState={focusState}
                targetOrigin={targetOrigin}
                anchorOrigin={anchorOrigin}
                menuItems={menuItems}
                innerDivStyle={Object.assign({}, innerDivStyle)}
                style={
                    this.props.showMenuItemNewStyle
                        ? Object.assign({}, Style.menuItemStyle, {
                              color: "#3c424e",
                              padding: "4px 0px"
                          })
                        : this.props.style
                }
            />
        );
    }
}
